import { TextWithMarkdownLinks } from "src/integrationNode/editorComponents/TextWithMarkdownLinks";
import { InputMapping } from "src/integrationNode/types";

export const InputMappingRowTooltipBody = ({
  type,
  hint,
  beType,
  rules,
  example,
}: InputMapping) => {
  const lengthUnit = type === "text" ? "character" : "item";

  return (
    <div className="space-y-2 font-fira-code">
      {hint && (
        <p className="font-inter-normal-12px">
          {hint.split("\n").map((line, i) => (
            <p key={i}>
              <TextWithMarkdownLinks text={line} type="tooltip" />
            </p>
          ))}
        </p>
      )}
      {beType && (
        <p className="font-bold">
          Type:{" "}
          <span className="font-normal">
            {Array.isArray(beType) ? beType.join(" | ") : beType}
          </span>
        </p>
      )}
      {rules?.minLength && (
        <p className="font-bold">
          Minimum length:{" "}
          <span className="font-normal">
            {rules?.minLength === 1
              ? `1 ${lengthUnit}`
              : `${rules?.minLength} ${lengthUnit}s`}
          </span>
        </p>
      )}
      {rules?.maxLength && (
        <p className="font-bold">
          Maximum length:{" "}
          <span className="font-normal">
            {rules?.maxLength === 1
              ? `1 ${lengthUnit}`
              : `${rules?.maxLength} ${lengthUnit}s`}
          </span>
        </p>
      )}
      {example && (
        <p className="font-bold">
          Example: <span className="font-normal">{example}</span>
        </p>
      )}
    </div>
  );
};
